const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20woman%2C%20casual%20style%2C%20warm%20smile%2C%20clean%20white%20background%2C%20studio%20lighting%2C%20natural%20look%2C%20professional%20but%20friendly&width=120&height=120&seq=avatar-chigua-01&orientation=squarish',
    name: '吃瓜第一线',
    time: '2小时前',
    content: '这瓜保熟吗？我看完觉得至少有三处细节对得上之前的爆料，坐等后续锤。小编速度真的快，其他地方还没发，这里已经有了！',
    likes: '2.3万',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20man%2C%20stylish%20casual%20outfit%2C%20confident%20expression%2C%20clean%20background%2C%20studio%20portrait%20lighting%2C%20modern%20look&width=120&height=120&seq=avatar-chigua-02&orientation=squarish',
    name: '娱乐圈观察员',
    time: '3小时前',
    content: '作为一个追了十年娱乐八卦的老瓜友，这个爆料的可信度我给8分。时间线、地点、人物关系都对得上，等一个官宣。',
    likes: '1.8万',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20woman%20with%20glasses%2C%20intellectual%20look%2C%20soft%20smile%2C%20clean%20studio%20background%2C%20warm%20lighting%2C%20modern%20professional%20style&width=120&height=120&seq=avatar-chigua-03&orientation=squarish',
    name: '理性吃瓜人',
    time: '5小时前',
    content: '理性讨论，不吹不黑。这个瓜如果属实的话，对整个圈子格局影响还挺大的。但我建议大家先别急着站队，让子弹再飞一会儿。',
    likes: '9.6k',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Chinese%20man%20with%20stylish%20haircut%2C%20trendy%20outfit%2C%20friendly%20expression%2C%20clean%20background%2C%20studio%20portrait%2C%20warm%20lighting&width=120&height=120&seq=avatar-chigua-04&orientation=squarish',
    name: '八卦课代表',
    time: '6小时前',
    content: '课代表来划重点了：①男方确实在横店拍戏期间 ②女方近期IP也在横店 ③两人去年曾同台互动。这三点对得上，剩下的大家自己品。',
    likes: '1.5万',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
              瓜友热评
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
              瓜友热评
            </h2>
            <p className="text-foreground-600 text-sm max-w-lg mx-auto">
              千万瓜友的真实声音，看看大家怎么说
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-5xl mx-auto">
            {comments.map((c) => (
              <div
                key={c.name}
                className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200"
              >
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-10 h-10 flex-shrink-0 rounded-full overflow-hidden bg-background-200">
                    <img
                      src={c.avatar}
                      alt={c.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                      onError={(e) => {
                        (e.currentTarget as HTMLElement).style.display = 'none';
                      }}
                    />
                  </div>
                  <div className="min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="font-semibold text-sm text-foreground-900">{c.name}</span>
                      <span className="text-xs text-foreground-400">{c.time}</span>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mt-2">
                      {c.content}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-4 pl-14">
                  <button className="flex items-center gap-1.5 text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">
                    <i className="ri-thumb-up-line"></i>
                    {c.likes}
                  </button>
                  <button className="flex items-center gap-1.5 text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">
                    <i className="ri-chat-1-line"></i>
                    回复
                  </button>
                  <button className="flex items-center gap-1.5 text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">
                    <i className="ri-share-forward-line"></i>
                    分享
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}